import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { ZONES_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const LOAD_LIST = '_LOAD_LIST';
export const LOAD_POSITION_BY_CAMERA_LIST = '_LOAD_POSITION_BY_CAMERA_LIST';
export const LOAD_ZONES_BY_CAMERA_LIST = '_LOAD_ZONES_BY_CAMERA_LIST';
export const CREATE_POSITION = '_CREATE_POSITION';
export const SAVE_POSITION = '_SAVE_POSITION';
export const DELETE_POSITION = '_DELETE_POSITION';
export const CREATE_ZONE = '_CREATE_ZONE';
export const SAVE_ZONE = '_SAVE_ZONE';
export const DELETE_ZONE = '_DELETE_ZONE';

export const loadList = createDeferredAction(ZONES_MODULE + LOAD_LIST);
export const loadListSuccessful = createAction(ZONES_MODULE + LOAD_LIST + SUCCESSFUL);
export const loadListFailed = createAction(ZONES_MODULE + LOAD_LIST + FAILED);

export const loadPositionByCameraList = createDeferredAction(ZONES_MODULE + LOAD_POSITION_BY_CAMERA_LIST);
export const loadPositionByCameraListSuccessful = createAction(ZONES_MODULE + LOAD_POSITION_BY_CAMERA_LIST + SUCCESSFUL);
export const loadPositionByCameraListFailed = createAction(ZONES_MODULE + LOAD_POSITION_BY_CAMERA_LIST + FAILED);

export const createPosition = createDeferredAction(ZONES_MODULE + CREATE_POSITION);
export const createPositionSuccessful = createAction(ZONES_MODULE + CREATE_POSITION + SUCCESSFUL);
export const createPositionFailed = createAction(ZONES_MODULE + CREATE_POSITION + FAILED);

export const savePosition = createDeferredAction(ZONES_MODULE + SAVE_POSITION);
export const savePositionSuccessful = createAction(ZONES_MODULE + SAVE_POSITION + SUCCESSFUL);
export const savePositionFailed = createAction(ZONES_MODULE + SAVE_POSITION + FAILED);

export const deletePosition = createDeferredAction(ZONES_MODULE + DELETE_POSITION);
export const deletePositionSuccessful = createAction(ZONES_MODULE + DELETE_POSITION + SUCCESSFUL);
export const deletePositionFailed = createAction(ZONES_MODULE + DELETE_POSITION + FAILED);

export const loadZonesByCameraList = createDeferredAction(ZONES_MODULE + LOAD_ZONES_BY_CAMERA_LIST);
export const loadZonesByCameraListSuccessful = createAction(ZONES_MODULE + LOAD_ZONES_BY_CAMERA_LIST + SUCCESSFUL);
export const loadZonesByCameraListFailed = createAction(ZONES_MODULE + LOAD_ZONES_BY_CAMERA_LIST + FAILED);

export const createZone = createDeferredAction(ZONES_MODULE + CREATE_ZONE);
export const createZoneSuccessful = createAction(ZONES_MODULE + CREATE_ZONE + SUCCESSFUL);
export const createZoneFailed = createAction(ZONES_MODULE + CREATE_ZONE + FAILED);

export const saveZone = createDeferredAction(ZONES_MODULE + SAVE_ZONE);
export const saveZoneSuccessful = createAction(ZONES_MODULE + SAVE_ZONE + SUCCESSFUL);
export const saveZoneFailed = createAction(ZONES_MODULE + SAVE_ZONE + FAILED);

export const deleteZone = createDeferredAction(ZONES_MODULE + DELETE_ZONE);
export const deleteZoneSuccessful = createAction(ZONES_MODULE + DELETE_ZONE + SUCCESSFUL);
export const deleteZoneFailed = createAction(ZONES_MODULE + DELETE_ZONE + FAILED);
